//──── Appointments ──────────────────────────────────────────────────────────────────────
const LOAD_TODAY_APPOINTMENTS_SUCCESS = 'LOAD_TODAY_APPOINTMENTS_SUCCESS';
const LOAD_TODAY_APPOINTMENTS_ERROR = 'LOAD_TODAY_APPOINTMENTS_ERROR';
const CHANGE_APPOINTMENT_STATUS = 'CHANGE_APPOINTMENT_STATUS';

// update
const RESET_SINGLE_APPOINTMENT_IN_LIST = 'RESET_SINGLE_APPOINTMENT_IN_LIST';
const UPDATE_SINGLE_APPOINTMENT_IN_LIST = 'UPDATE_SINGLE_APPOINTMENT_IN_LIST';
const UPDATE_SINGLE_APPOINTMENT_IN_LIST_SUCCESS = 'UPDATE_SINGLE_APPOINTMENT_IN_LIST_SUCCESS';
const UPDATE_SINGLE_APPOINTMENT_IN_LIST_ERROR = 'UPDATE_SINGLE_APPOINTMENT_IN_LIST_ERROR';

// unplanned
const SET_UNPLANNED_APPOINTMENTS = 'SET_UNPLANNED_APPOINTMENTS';
const REMOVE_UNPLANNED_APPOINTMENT_BY_ID = 'REMOVE_UNPLANNED_APPOINTMENT_BY_ID';

const PATIENT_ARRIVED_SUCCESS = 'PATIENT_ARRIVED_SUCCESS';
const PATIENT_ARRIVED_ERROR = 'PATIENT_ARRIVED_ERROR';

//──── Filter ────────────────────────────────────────────────────────────────────────────
const RESET_APPOINTMENTS_FILTERS = 'RESET_APPOINTMENTS_FILTERS';
const SET_FILTER_APPOINTMENT_STATUSES = 'SET_FILTER_APPOINTMENT_STATUSES';
const UPDATE_FILTER_APPOINTMENT_STATUS = 'UPDATE_FILTER_APPOINTMENT_STATUS';
const CLEAR_LIST = 'CLEAR_LIST';

export default {
  LOAD_TODAY_APPOINTMENTS_SUCCESS,
  LOAD_TODAY_APPOINTMENTS_ERROR,
  CHANGE_APPOINTMENT_STATUS,
  UPDATE_SINGLE_APPOINTMENT_IN_LIST,
  UPDATE_SINGLE_APPOINTMENT_IN_LIST_SUCCESS,
  UPDATE_SINGLE_APPOINTMENT_IN_LIST_ERROR,
  PATIENT_ARRIVED_SUCCESS,
  PATIENT_ARRIVED_ERROR,
  RESET_SINGLE_APPOINTMENT_IN_LIST,
  CLEAR_LIST,
  //──── Filters ───────────────────────────────────────────────────────────────────────────
  RESET_APPOINTMENTS_FILTERS,
  // Unplanned
  SET_UNPLANNED_APPOINTMENTS,
  REMOVE_UNPLANNED_APPOINTMENT_BY_ID,
  // Appointments statuses
  SET_FILTER_APPOINTMENT_STATUSES,
  UPDATE_FILTER_APPOINTMENT_STATUS
};
